import { CompanyAvatar, UserAvatar, UserAvatarProps } from "@eworkit/iris";
import React, { FC } from "react";

import { LazyImg } from "@/components/Fetcher";
import { IAttachment } from "@/data/attachments";
import { ICompany } from "@/data/companies";
import { LazyLoadedLogo, LogoPlaceholder } from "@/views/components/Logo";

import "./_lazy-avatar.scss";

interface LazyUserAvatarProps extends Omit<UserAvatarProps, "img"> {
  avatar?: IAttachment | null;
  company?: ICompany | null;
  showCompanyPlaceholder?: boolean;
}
/**
 * @deprecated Use iris-based LazyUserAvatar from components implementation instead.
 */
export const LazyUserAvatar: FC<LazyUserAvatarProps> = ({
  avatar,
  company,
  showCompanyPlaceholder,
  ...avatarProps
}) => {
  const baseClass = "lazy-avatar";

  return (
    <div className={baseClass}>
      {avatar ? (
        <LazyImg systemId={avatar.systemId}>
          {data =>
            data.payload && data.payload.publicUrl ? (
              <UserAvatar img={data.payload.publicUrl} {...avatarProps} />
            ) : (
              <UserAvatar {...avatarProps} />
            )
          }
        </LazyImg>
      ) : (
        <UserAvatar {...avatarProps} />
      )}
      {company && (
        <LazyLoadedLogo logo={company.logo}>
          {publicUrl =>
            publicUrl ? (
              <div className={`${baseClass}__company-border`}>
                <CompanyAvatar className={`${baseClass}__company-logo`} img={publicUrl} size="xxs" />
              </div>
            ) : (
              <div className={`${baseClass}__company-border`}>
                <div className={`${baseClass}__company-logo`}>
                  <LogoPlaceholder size="xxs" iconSize="xs" />
                </div>
              </div>
            )
          }
        </LazyLoadedLogo>
      )}
    </div>
  );
};
